// MIT License
// Copyright (c) 2019-present StringEpsilon <StringEpsilon@gmail.com>
// Copyright (c) 2017-2019 James Kyle <me@thejameskyle.com>
// https://github.com/StringEpsilon/mini-create-react-context
import React from "react";
import createReactContext from "./miniCreateReactContext";

export default React.createContext || createReactContext;
